import { z } from 'zod';
export const PointLedgerPostedPayload = z.object({
    poolId: z.string().uuid(),
    userId: z.string().uuid(),
    ledgerEntryId: z.string().uuid(),
    amount: z.number().int(),
    category: z.string(),
});
export const RewardRedeemedPayload = z.object({
    poolId: z.string().uuid(),
    rewardItemId: z.string().uuid(),
    redemptionId: z.string().uuid(),
    userId: z.string().uuid(),
    pointsSpent: z.number().int().positive(),
});
//# sourceMappingURL=events.js.map